import React from 'react';
import { Icon } from './Icon.js';
export const IconBookmarkFilled = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m16,17l-6-4-6,4V6c0-1.657,1.343-3,3-3h6c1.657,0,3,1.343,3,3v11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", fill: "currentColor" })));
};
//# sourceMappingURL=IconBookmarkFilled.js.map